// src/store/slices/cart-slice.js
import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  cartItems: []
};

// helper: find an existing item by product identity + variant fields
const findCartItem = (items, p) => {
  return items.find(item =>
    item.id === p.id &&
    // if the product has variants, also match on selected color (add size if you use it)
    (!p.variation || item.selectedProductColor === p.selectedProductColor) &&
    // if caller specifies a cartItemId, match that exact one
    (!p.cartItemId || item.cartItemId === p.cartItemId)
  );
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart(state, action) {
      const p = action.payload;
      const existing = findCartItem(state.cartItems, p);

      if (!existing) {
        state.cartItems.push({
          ...p,
          quantity: p.quantity ? p.quantity : 1,
          cartItemId: uuidv4()
        });
      } else {
        existing.quantity += p.quantity ? p.quantity : 1;
        // keep selectedProductColor in sync if passed
        if (p.selectedProductColor !== undefined) {
          existing.selectedProductColor = p.selectedProductColor;
        }
      }
    },

    // pass either cartItemId (string) OR the whole item (with cartItemId)
    decreaseQuantity(state, action) {
      const id =
        typeof action.payload === 'string'
          ? action.payload
          : action.payload.cartItemId;

      const item = state.cartItems.find(i => i.cartItemId === id);
      if (!item) return;

      if (item.quantity <= 1) {
        state.cartItems = state.cartItems.filter(i => i.cartItemId !== id);
      } else {
        item.quantity -= 1;
      }
    },

    deleteFromCart(state, action) {
      const id =
        typeof action.payload === 'string'
          ? action.payload
          : action.payload.cartItemId;
      state.cartItems = state.cartItems.filter(i => i.cartItemId !== id);
    },

    deleteAllFromCart(state) {
      state.cartItems = [];
    }
  }
});

export const {
  addToCart,
  decreaseQuantity,
  deleteFromCart,
  deleteAllFromCart
} = cartSlice.actions;

export default cartSlice.reducer;
